import { useEffect, useState, useContext } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Card, Row, Logo } from 'components/lib';
import { AuthContext } from '../../../app/authContext';
import { authClient, verifyEmail } from '../../../lib/auth-client';
import { UMButton } from '@urbanmetrix/um-kit';
import { getApiErrorMessage } from 'api/apiClient';

export function EmailConfirmed() {
  const authContext = useContext(AuthContext);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying');
  const [message, setMessage] = useState('Please wait while we confirm your email.');

  useEffect(() => {
    let active = true;

    async function confirmEmail() {
      if (!token) {
        if (!active) return;
        setStatus('error');
        setMessage('Missing verification token.');
        return;
      }

      try {
        await verifyEmail(token);
        await authClient.getSession();

        if (!active) return;

        setStatus('success');
        setMessage('Email confirmed. Redirecting...');
        window.location.href = '/dashboard';
      } catch (error) {
        if (!active) return;
        setStatus('error');
        setMessage(getApiErrorMessage(error, 'Unable to confirm your email.'));
      }
    }

    void confirmEmail();

    return () => {
      active = false;
    };
  }, [token]);

  return (
    <Row title="Email confirmation" customClass="auth-form-row">
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          marginBottom: '15px',
        }}
      >
        <Logo />
      </div>

      <Card restrictWidth center extraClass="form-container" isStat={true}>
        <p style={{ marginBottom: '16px' }}>{message}</p>
        {status === 'error' && (
          <UMButton
            text={authContext?.isAuthenticated ? 'Go to dashboard' : 'Go to login'}
            onClick={() => navigate(authContext?.isAuthenticated ? '/dashboard' : '/login')}
            fullWidth
          />
        )}
      </Card>
    </Row>
  );
}
